//  学而思网校(素质) biz
export const BIZ_WANGXIAO = 10
// 高中 biz
export const BIZ_GAOZHOGN = 20
// 新学科 biz
export const BIZ_XINXUEKE = 30
// 素质+高中 PC
export const BIZ_PC = 40

export const BIZID_NAME = 'X-Businessline-Id'

export const URL_APP_BLID = 'app_blid'

export const SIDE_BAR_DATA = [{
  'name': '扫码下载',
  'type': 2,
  'order': 1,
  'url': '',
  'target': 2,
  'icon': 'https://mr.xesimg.com/xes-incr-mall-admin/2021/12/01/16383533668469.png',
  'icon_hover': 'https://hw.xesimg.com/xes-incr-mall-admin/2021/12/01/16383533878648.png',
  'img': 'https://ek.xesimg.com/xes-incr-mall-admin/2021/12/01/16383534934278.png',
  'content': '扫码下载学而思网校APP<br>获取中小学在线辅导直播课'
},
{
  'name': '购物车',
  'type': 3,
  'order': 2,
  'url': 'https://trade.xueersi.com/shopCartWeb/#/cart',
  'target': 1,
  'icon': 'https://ek.xesimg.com/xes-incr-mall-admin/2021/12/01/16383534595485.png',
  'icon_hover': 'https://mr.xesimg.com/xes-incr-mall-admin/2021/12/01/16383534721639.png',
  'img': 'https://ek.xesimg.com/xes-incr-mall-admin/2021/12/01/16383534934278.png',
  'content': '扫码下载学而思网校APP<br>获己内酰胺DNA'
},
{
  'name': '咨询',
  'type': 4,
  'order': 3,
  'url': 'https://app.xueersi.com/polymerh5/app/#/chat?key=12',
  'target': 1,
  'icon': 'https://mr.xesimg.com/xes-incr-mall-admin/2021/12/01/16383534138325.png',
  'icon_hover': 'https://oo.xesimg.com/xes-incr-mall-admin/2021/12/01/16383534414215.png',
  'img': 'https://ek.xesimg.com/xes-incr-mall-admin/2021/12/01/16383534934278.png',
  'content': '在线客服'
},
{
  'name': '反馈',
  'type': 5,
  'order': 4,
  'url': 'https://app.xueersi.com/servicepc/#/feedback?channelId=1&businessId=1&subBusinessId=1&roleId=4&sourceFrom=xeswxpc',
  'target': 2,
  'icon': 'https://mr.xesimg.com/xes-incr-mall-admin/2021/12/01/16383532666534.png',
  'icon_hover': 'https://hw.xesimg.com/xes-incr-mall-admin/2021/12/01/16383532851957.png',
  'img': '',
  'content': '意见反馈'
}]



// WEBPACK FOOTER //
// ./common/assets/js/const.js